<template>
  <b-modal
    ref="modal"
    hide-footer
    no-close-on-backdrop
    content-class="import-modal-content"
    dialog-class="import-modal-dialog"
    :title="labels.title"
  >
    <div class="user-importer-wrapper">
      <b-form-file
        v-model="file"
        :browse-text="labels.form.file.button"
        :placeholder="labels.form.file.placeholder"
        no-drop
        accept=".xls, .xlsx"
        @change="readSheet"
      />

      <div class="sheet-selection mt-2" v-if="sheets.length > 0">
        <b-row>
          <b-col cols="12" xl="6">
            <b-form-group>
              <b-form-select @change="selectUserSheet">
                <option
                  v-for="(wsname, index) in sheets"
                  :key="`sheet-${index}`"
                  :value="wsname"
                >
                  {{ wsname }}
                </option>
              </b-form-select>
              <label class="custom-input-label">
                {{ labels.form.sheet.users }}
              </label>
              <label class="mdi mdi-chevron-down select-icon"></label>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="sheet-data-mapping" v-if="keys.length > 0">
          <hr />
          <b-row>
            <b-col cols="6" xl="6">
              <b-form-group>
                <b-form-select @input="selectMapping($event, 'firstName')">
                  <option
                    v-for="(key, keyIdx) in keys"
                    :key="`sheet-${keyIdx}`"
                    :value="key"
                  >
                    {{ key }}
                  </option>
                </b-form-select>
                <label class="custom-input-label">
                  {{ labels.form.sheet.firstName }}
                </label>
                <label class="mdi mdi-chevron-down select-icon"></label>
              </b-form-group>
            </b-col>
            <b-col cols="6" xl="6">
              <b-form-group>
                <b-form-select @input="selectMapping($event, 'lastName')">
                  <option
                    v-for="(key, keyIdx) in keys"
                    :key="`sheet-${keyIdx}`"
                    :value="key"
                  >
                    {{ key }}
                  </option>
                </b-form-select>
                <label class="custom-input-label">
                  {{ labels.form.sheet.lastName }}
                </label>
                <label class="mdi mdi-chevron-down select-icon"></label>
              </b-form-group>
            </b-col>
            <b-col cols="6" xl="6">
              <b-form-group>
                <b-form-select @input="selectMapping($event, 'email')">
                  <option
                    v-for="(key, keyIdx) in keys"
                    :key="`sheet-${keyIdx}`"
                    :value="key"
                  >
                    {{ key }}
                  </option>
                </b-form-select>
                <label class="custom-input-label">
                  {{ labels.form.sheet.email }}
                </label>
                <label class="mdi mdi-chevron-down select-icon"></label>
              </b-form-group>
            </b-col>
            <b-col cols="6" xl="6">
              <b-form-group>
                <b-form-select @input="selectMapping($event, 'role')">
                  <option
                    v-for="(key, keyIdx) in keys"
                    :key="`sheet-${keyIdx}`"
                    :value="key"
                  >
                    {{ key }}
                  </option>
                </b-form-select>
                <label class="custom-input-label">
                  {{ labels.form.sheet.role }}
                </label>
                <label class="mdi mdi-chevron-down select-icon"></label>
              </b-form-group>
            </b-col>
            <b-col cols="6" xl="6" v-if="$can('super', 'user')">
              <b-form-group>
                <b-form-select @input="selectMapping($event, 'code')">
                  <option
                    v-for="(key, keyIdx) in keys"
                    :key="`sheet-${keyIdx}`"
                    :value="key"
                  >
                    {{ key }}
                  </option>
                </b-form-select>
                <label class="custom-input-label">
                  {{ labels.form.sheet.code }}
                </label>
                <label class="mdi mdi-chevron-down select-icon"></label>
              </b-form-group>
            </b-col>
            <b-col cols="6" xl="6">
              <b-form-group>
                <b-form-select @input="selectMapping($event, 'birthDate')">
                  <option
                    v-for="(key, keyIdx) in keys"
                    :key="`sheet-${keyIdx}`"
                    :value="key"
                  >
                    {{ key }}
                  </option>
                </b-form-select>
                <label class="custom-input-label">
                  {{ labels.form.sheet.birthDate }}
                </label>
                <label class="mdi mdi-chevron-down select-icon"></label>
              </b-form-group>
            </b-col>
            <b-col cols="6" xl="6">
              <b-form-group>
                <b-form-select @input="selectMapping($event, 'attributes')">
                  <option
                    v-for="(key, keyIdx) in keys"
                    :key="`sheet-${keyIdx}`"
                    :value="key"
                  >
                    {{ key }}
                  </option>
                </b-form-select>
                <label class="custom-input-label">
                  {{ labels.form.sheet.userAttributes }}
                </label>
                <label class="mdi mdi-chevron-down select-icon"></label>
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <div class="load-users-button text-center">
            <button
              v-if="users.length === 0"
              type="button"
              class="btn btn-tertiary btn-lg"
              @click="loadUsers"
            >
              <i class="material-icons">
                file_upload
              </i>
              <span class="ml-2">
                {{ labels.form.loadUsers }}
              </span>
            </button>
          </div>
        </div>
      </div>

      <div class="sheet-data-found text-center" v-if="users.length > 0">
        <p>
          <i class="mdi mdi-spin mdi-loading pr-2" v-if="loadingValidation"></i>
          <span v-if="loadingValidation">{{ loadingValidationMessage }}</span>
          <span v-else>
            {{ labels.form.foundUsers | parse({ USERS: users.length }) }}
          </span>
        </p>
        <button
          type="button"
          class="btn btn-secondary"
          @click="loadInviteUsers"
          :disabled="loadingValidation"
        >
          <span class="ml-2">
            {{ labels.form.validateLoadUsers }}
          </span>
        </button>

        <b-alert
          show
          class="alert-secondary mt-4"
          v-if="loadingValidationErrors.length > 0"
        >
          <p
            :key="`error-${index}`"
            v-for="(error, index) in loadingValidationErrors"
          >
            {{ error }}
          </p>
        </b-alert>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'

const KEYS_USER = {
  firstName: null,
  lastName: null,
  email: null,
  role: null,
  birthDate: null,
  code: null,
}

export default {
  components: {},

  data: function() {
    return {
      loading: false,
      file: null,
      workbook: null,
      sheet: null,
      keys: [],
      keysUser: KEYS_USER,
      users: [],
    }
  },

  computed: {
    ...mapGetters({
      resources: 'resources',
      licenses: 'company/licenses',
      loadingValidation: 'sendInvites/loadingValidation',
      loadingValidationMessage: 'sendInvites/loadingValidationMessage',
      loadingValidationErrors: 'sendInvites/loadingValidationErrors',
      userAttributes: 'userAttributes/filterUserAttributes',
    }),

    labels() {
      return this.resources.component.userImporter
    },

    rolesMap() {
      return Object.keys(this.resources.general.input.roles).reduce(
        (map, key) => {
          map[this.resources.general.input.roles[key].toLowerCase()] = key
          return map
        },
        {}
      )
    },

    sheets() {
      const workbook = this.workbook || { SheetNames: [] }
      return workbook.SheetNames
    },

    userAttributesMap() {
      const userAttributes = this.userAttributes
      const userAttributesMap = {}
      userAttributes.forEach(userAttribute => {
        userAttributesMap[userAttribute.label] = {
          id: userAttribute.id,
          values: userAttribute.values.reduce((map, item) => {
            map[item.label] = item.id
            return map
          }, {}),
        }
      })
      return userAttributesMap
    },
  },

  methods: {
    clearForm() {
      this.workbook = null
      this.sheet = null
      this.keys = []
      this.keysUser = KEYS_USER
      this.users = []
    },

    show() {
      this.file = null
      this.clearForm()
      this.$refs.modal.show()
    },

    getUserAttributes(attributes) {
      if (!attributes) {
        return []
      }
      const userAttributesMap = this.userAttributesMap
      const userAttributes = attributes.split('|').map(a => a.trim())
      return userAttributes.reduce((list, item) => {
        const userAttribute = item.split(':').map(a => a.trim())
        const userAttributeRef = userAttributesMap[userAttribute[0]]
        if (userAttributeRef) {
          const value = userAttributeRef.values[userAttribute[1]]
          list.push({ key: userAttributeRef.id, value })
        }
        return list
      }, [])
    },

    getCode(code) {
      const cleanCode = String(code || '')
        .trim()
        .replace(/\./g, '')
        .replace(/-/g, '')

      return cleanCode === '' ? '' : String(cleanCode).padStart(11, '0')
    },

    getBirthdate(birthDate) {
      if (!birthDate) {
        return null
      }

      if (typeof birthDate === 'string') {
        return birthDate
          .trim()
          .split('/')
          .reverse()
          .join('-')
      }

      const date = new Date(Math.round((birthDate - 25569) * 86400 * 1000))
      return JSON.parse(JSON.stringify(date).replace('T00:00:00.000Z', ''))
    },

    async loadInviteUsers() {
      this.$store.commit('sendInvites/resetLoadingValidation')
      const users = this.users || []

      const { remainingLicenses } = this.licenses
      if (remainingLicenses < users.length) {
        const message = this.labels.remainingLicenses
        this.$store.commit('sendInvites/addLoadingValidationError', message)
        return false
      }

      // remove old users from form
      if (users.length > 0) {
        this.$store.commit('sendInvites/clearForm')
      }

      await this.$store.dispatch('sendInvites/loadInviteUsers', users)

      this.$refs.modal.hide()
    },

    loadUsers() {
      const {
        firstName = false,
        lastName = false,
        email = false,
        role = false,
        birthDate = false,
        code = false,
        attributes = false,
      } = this.keysUser

      const users = []
      this.sheet.forEach(user => {
        const u = {
          firstName: firstName ? String(user[firstName] || '').trim() : null,
          lastName: lastName ? String(user[lastName] || '').trim() : null,
          email: email
            ? String(user[email] || '')
                .trim()
                .toLowerCase()
            : null,
          role: role
            ? this.rolesMap[
                String(user[role] || '')
                  .trim()
                  .toLowerCase()
              ]
            : null,
          code: code ? this.getCode(user[code]) : null,
          birthDate: birthDate ? this.getBirthdate(user[birthDate]) : null,
          attributes: attributes
            ? this.getUserAttributes(user[attributes])
            : [],
        }
        users.push(u)
      })
      this.users = users
    },

    readSheet(e) {
      const files = e.target.files
      const fileReader = new FileReader()
      fileReader.onload = event => {
        this.clearForm()
        this.workbook = XLSX.read(event.target.result, { type: 'binary' })
      }
      fileReader.readAsBinaryString(files[0])
    },

    selectMapping(value, mapping) {
      this.keysUser[mapping] = value
    },

    selectUserSheet(wsname) {
      const sheet = XLSX.utils.sheet_to_json(this.workbook.Sheets[wsname], {
        defval: null,
      })
      this.sheet = sheet
      this.keys = sheet && sheet.length > 0 ? Object.keys(sheet[0]) : []
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';

.user-importer-wrapper {
  .alert-secondary {
    color: map-get($theme-colors, 'white') !important;
    background-color: map-get($theme-colors, 'secondary') !important;
    font-size: 0.8em !important;
    position: relative !important;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.25rem !important;

    .material-icons {
      margin-right: 10px;
      line-height: inherit !important;
    }
  }
}
</style>
